// 菜谱列表混入
import {requestByTip} from "@/config/request";

export default {
  methods: {
    // 批量删除
    getList() {
      return this.$refs.list;
    },

    // 查看食谱
    handleCheckRecipe(row) {
      this.$router.push({
        path: "detail",
        query: {
          num: row.num
        }
      })
    },

    // 删除食谱
    async handleDeleteRecipe(row) {
      try {
        await requestByTip(this.$api.cookbook.delete, {code: row.code});
        this.$message.success("删除成功");
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.log(e);
      }
    },

    // 跳转相似菜谱
    handleSimilarRecipe(row) {
      const {num} = row;
      const params =  {num};
      this.$router.push({
        path: "/similar-recipe/list",
        query: params
      })

    }
  }


}
